(function ($) {
  $(function () {
    const $bar = $('.phent-sticky-cart');
    const $form = $('form.cart').first();
    if (!$bar.length || !$form.length) return;

    // Show the bar once the add-to-cart form is scrolled out of view (above).
    function toggle() {
      const rect = $form[0].getBoundingClientRect();
      const passed = rect.bottom < 0;
      $bar.toggleClass('is-visible', passed);
      // Lets app.scss lift the WhatsApp button clear of the bar.
      $('body').toggleClass('phent-sticky-cart-visible', passed);
    }

    $(window).on('scroll resize', toggle);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(toggle, { threshold: 0 }).observe($form[0]);
    }
    toggle();

    $bar.on('click', '.phent-sticky-cart__button', function () {
      if ($(this).data('variable')) {
        // Variable product: scroll back up to the options.
        $('html, body').animate({ scrollTop: $form.offset().top - 140 }, 400);
      } else {
        $form.trigger('submit');
      }
    });
  });
})(jQuery);
